<template>
  <div class="bg-gray-50 dark:bg-gray-900 rounded-xl border-gray-100 dark:border-gray-700/50">
    <div class="flex items-center gap-3 mb-2">
      <div
        :class="[
          'w-8 h-8 rounded-xl flex items-center justify-center',
          iconBgClass
        ]"
      >
        <div :class="['w-3 h-3 rounded-full', iconColorClass]" />
      </div>
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ label }}
      </span>
    </div>
    <p class="text-lg font-semibold text-gray-900 dark:text-gray-100">
      {{ value }}
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  value: string;
  iconBgClass: string;
  iconColorClass: string;
}

defineProps<Props>();
</script>
